var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};



//////////////////
// WEBPACK FOOTER
// /usr/local/app/~/core-js/modules/_uid.js
// module id = ../../../../core-js/modules/_uid.js
// module chunks = 0